import { useEffect } from "react";
import { getStyleOverride } from "utils/geniusChatUtils";

export const useChatVisibility = (isOpen: boolean): void => {
  useEffect(() => {
    getStyleOverride("gCVisibility").textContent = `
          #dg-chat-widget-launcher {
            display: ${isOpen ? "none" : "block"} !important;
          }
          #dg-chat-widget {
            display: ${isOpen ? "none" : "block"} !important;
          }
        `;

    return () => {
      getStyleOverride("gCVisibility").textContent = `
            #dg-chat-widget-launcher {
              display: ${isOpen ? "none" : "block"} !important;
            }
            #dg-chat-widget {
              display: ${isOpen ? "none" : "block"} !important;
            }
          `;
    };
  }, [isOpen]);
};
